import {$, w} from './constants';
import { trackEvent } from "./gtm.js";
let first_play = false;
let first_play_hero = false;

export function playVideo()  {
    var video = $('#video_src').get(0);

    $('#video_play').click(function() {
        $(this).addClass('hide');
        $('#video_controls').removeClass('hide');
        video.play();
        video.muted = false;
        if( first_play == false ){
            first_play = true;
            $('#video_thumbnail').addClass('hide');
        }
    });

    $('#video_pause').click(function() {
        $('#video_controls').addClass('hide');
        $('#video_play').removeClass('hide');
        video.pause();
        video.muted = true;
        $('#video_audio_on').removeClass('hide');
        $('#video_audio_off').addClass('hide');
    });

    $('#video_audio_on').click(function() {
        $(this).addClass('hide');
        $('#video_audio_off').removeClass('hide');
        video.muted = true;
    });

    $('#video_audio_off').click(function() {
        $(this).addClass('hide');
        $('#video_audio_on').removeClass('hide');
        video.muted = false;
    });
}

export function playVideoHero() {
    // Seleccionar todos los videos
    const videos = document.querySelectorAll(".video_hero_src");

    videos.forEach((video) => {
        // Obtener los eventos desde los atributos data-event-gtm-*
        const videoName = video.id;
        const gtmStart = video.getAttribute("data-event-gtm-start");
        const gtmProgress = video.getAttribute("data-event-gtm-progress");
        const gtmComplete = video.getAttribute("data-event-gtm-complete");

        let progressTracked = {
            25: false,
            50: false,
            75: false
        };

        let firstPlay = false; // Variable para saber si es la primera vez que se reproduce

        const videoContainer = video.closest(".video-container");
        const playButton = videoContainer.querySelector(".video_hero_play");
        const pauseButton = videoContainer.querySelector(".video_hero_pause");
        const audioOnButton = videoContainer.querySelector(".video_hero_audio_on");
        const audioOffButton = videoContainer.querySelector(".video_hero_audio_off");
        const controls = videoContainer.querySelector(".video_hero_controls");
        const thumbnail = videoContainer.querySelector(".video_hero_thumbnail");

        playButton.addEventListener("click", function () {
            this.classList.add("hide");
            controls.classList.remove("hide");
            video.play();
            video.muted = false;
            if (!firstPlay && thumbnail) {
                firstPlay = true;
                thumbnail.classList.add("hide");
            }

            if (gtmStart) {
                trackEvent(gtmStart, {
                    videoName: videoName,
                    action: "start"
                });
            }
        });

        pauseButton.addEventListener("click", function () {
            controls.classList.add("hide");
            playButton.classList.remove("hide");
            video.pause();
            video.muted = true;
        });

        audioOnButton.addEventListener("click", function () {
            this.classList.add("hide");
            audioOffButton.classList.remove("hide");
            video.muted = true;
        });

        audioOffButton.addEventListener("click", function () {
            this.classList.add("hide");
            audioOnButton.classList.remove("hide");
            video.muted = false;
        });

        if (gtmProgress) {
            video.addEventListener("timeupdate", function () {
                const progress = (video.currentTime / video.duration) * 100;

                if (progress >= 25 && !progressTracked[25]) {
                    trackEvent(gtmProgress, { videoName: videoName, progress: "25%" });
                    progressTracked[25] = true;
                }
                if (progress >= 50 && !progressTracked[50]) {
                    trackEvent(gtmProgress, { videoName: videoName, progress: "50%" });
                    progressTracked[50] = true;
                }
                if (progress >= 75 && !progressTracked[75]) {
                    trackEvent(gtmProgress, { videoName: videoName, progress: "75%" });
                    progressTracked[75] = true;
                }
            });
        }
        if (gtmComplete) {
            video.addEventListener("ended", function () {
                trackEvent(gtmComplete, {
                    videoName: videoName,
                    action: "complete"
                });
            });
        }
    });
}

export function viewerVideo() {
  const $viewer = $('#video_viewer');
  const $wrapper = $viewer.find('.video-viewer__wrapper');
  const $closeBtn = $viewer.find('.video-viewer__close');

  // Usa delegación global para asegurar que funciona tras AJAX
  $(document).off('click.viewerVideo').on('click.viewerVideo', '.card__events', function(e) {
    if ($(e.target).is('a, button, .video-viewer__close')) return;

    const $card = $(this);
    const videoUrl = $card.data('video');

    if (videoUrl) {
      const embedUrl = convertToEmbedUrl(videoUrl);
      const iframe = `
        <iframe
          src="${embedUrl}?rel=0"
          frameborder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          referrerpolicy="strict-origin-when-cross-origin"
          width="100%"
          height="100%">
        </iframe>
      `;
      $wrapper.html(iframe);
      $viewer.fadeIn(300);
    }
  });

  $closeBtn.on('click', closeViewer);
  $viewer.on('click', function(e) {
    if ($(e.target).is('#video_viewer, .video-viewer__wrapper')) {
      closeViewer();
    }
  });
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') closeViewer();
  });

  function closeViewer() {
    $viewer.fadeOut(300);
    $wrapper.empty();
  }

  function convertToEmbedUrl(url) {
    const videoId = url.split('v=')[1]?.split('&')[0]
                  || url.split('youtu.be/')[1]?.split('?')[0]
                  || '';
    return `https://www.youtube.com/embed/${videoId}`;
  }
}

export function videoYT() {

    $(document).on('click', '.video-player--youtube .video_hero_play', function (e) {
  e.preventDefault();
  console.log('click')

  const $container = $(this).closest('.video-player--youtube');
  const $wrap = $container.find('.js-youtube-player-wrap');
  const videoUrl = $wrap.data('video');

  const videoId = videoUrl.split('v=')[1]?.split('&')[0]
              || videoUrl.split('youtu.be/')[1]?.split('?')[0]
              || '';

  if (!videoId) return;

  $wrap.html(`
    <iframe
      src="https://www.youtube.com/embed/${videoId}?rel=0"
      frameborder="0"
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      referrerpolicy="strict-origin-when-cross-origin"
      width="100%"
      height="100%">
    </iframe>
  `);

  $(this).addClass('hide');
  $container.find('.video_hero_thumbnail').addClass('hide');
});
}